export default __webpack_public_path__ + "static/cef3f7e4-d4f3-48ea-b532-61ecfca6b12d-f127359728610ddd140c6af88e46a3e6.woff";